import React from 'react';

const Error = ({errorMessage = ''}) => {
	return <div className='form-error'>{errorMessage}</div>;
};

const Wrapper = ({label, errorMessage = false, name, className, style, children = []}) => {

	return (
		<div className={(className || 'wrapper')} style={style}>
			{label && <label htmlFor={name}>{label}</label>}
			{children}
			{errorMessage && <Error errorMessage={errorMessage} /> }
		</div>
	);
};

export default Wrapper;